import React from 'react';
import { formatLeadIdLabel } from '../constants';

interface TaskInfoCardProps {
  leadId?: string | null;
  leadUniqueId?: string | null;
  leadUserId?: string | null;
  onLeadClick?: () => void;
  title: string;
  onTitleChange: (value: string) => void;
  readOnly?: boolean;
}

export const TaskInfoCard: React.FC<TaskInfoCardProps> = ({
  leadId,
  leadUniqueId,
  leadUserId,
  onLeadClick,
  title,
  onTitleChange,
  readOnly = false,
}) => {
  const leadIdLabel = formatLeadIdLabel(leadUniqueId) ?? formatLeadIdLabel(leadId);
  const canNavigate = Boolean(onLeadClick && (leadUserId || leadUniqueId || leadId));

  return (
    <section className="task-details-modal__card task-details-modal__info-card">
      {leadIdLabel && (
        canNavigate ? (
          <button
            type="button"
            className="task-details-modal__lead-id task-details-modal__lead-link"
            onClick={onLeadClick}
          >
            {leadIdLabel}
          </button>
        ) : (
          <span className="task-details-modal__lead-id">{leadIdLabel}</span>
        )
      )}
      <input
        type="text"
        className="task-details-modal__title-input"
        value={title}
        onChange={(e) => onTitleChange(e.target.value)}
        placeholder="Task title..."
        aria-label="Task title"
        readOnly={readOnly}
        disabled={readOnly}
      />
    </section>
  );
};
